import { render, staticRenderFns } from "./AddressStreet.vue?vue&type=template&id=5ca20cc0&"
import script from "./AddressStreet.vue?vue&type=script&lang=ts&"
export * from "./AddressStreet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports